import React, { useState, useEffect, useRef } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form'
import http from './../../../services/Api'
import swal from 'sweetalert';
import ReactInputMask from 'react-input-mask';
import { ModalManager } from 'react-dynamic-modal';


import 'react-phone-number-input/style.css'
import './index.css'
import { RiLoader4Line } from 'react-icons/ri';
import PasswordModal from '../PasswordModal/PasswordModal';

function ProfileForm({ data }) {
  const [loading, setLoading] = useState(false)
  const { register, handleSubmit, setValue, watch } = useForm();
  const password = useRef({});
  password.current = watch("password", "");

  useEffect(() => {
      init();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const init = async () => {
    setValue('name', data.name)
    setValue('username', data.username)
    setValue('email', data.email)
    setValue('phone', data.phone)
  }

  const verifyEmail = async email => {
    if (data.email !== email) {
      try {
        let response = await http.post(`/api/user/email-available`, { 'email': email });
        return response;
      } catch (e) {
        console.log(e)
        return e;
      }
    }
    let response = { data: false }
    return response
  }


  function openPasswordModal() {
    ModalManager.open(<PasswordModal />)
  }

  const save = async data => {
    const { email, name, phone, username } = data

    try{
      const response = await verifyEmail(email)
      if (!response.data) {
        try {
          setLoading(true)
          await http.post(`/api/profile/`, {
            name,
            username,
            email,
            phone
          })
          swal("Sucesso!", `Perfil editado com sucesso`, "success")
          setLoading(false);
        } catch (e) {
          swal("Erro!", "Não foi possível editar esse perfil", "error")
            .then(() => {
              window.location.reload();
            });
          console.log(e)
        }
      } else {
        swal('Erro!', "Email já cadastrado no sistema", "error")
        setLoading(false);
      }
    }catch(e){
      console.log(e);
    }
  }

  return (
    <div className="Profile-Form">
      <h1>Editar Perfil</h1>
      <Form method="POST" onSubmit={handleSubmit(save)}>
        <Form.Group as={Row} controlId="name">
          <Form.Label column sm="2">
            Nome
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" name="name" ref={register} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="Username">
          <Form.Label column sm="2">
            Usuário
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" name="username" ref={register} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="email">
          <Form.Label column sm="2">
            Email
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" name="email" ref={register} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="phone">
          <Form.Label column sm="2">
            Telefone
          </Form.Label>
          <Col sm="10">
            <ReactInputMask
              // mask="(99) 99999 9999"
              id="inlineFormInputGroupUsername2"
              placeholder="Digite seu telefone"
              type="text"
              name="phone"
              inputRef={register}
              required
              className="form-control"
            // pattern={[
            //   '^[0-9]*$'
            // ]}
            />
          </Col>
        </Form.Group>
        <Button variant="primary" type="submit">
          {loading ?
            <RiLoader4Line className="spin" />
            :
            'Salvar'
          }
        </Button>
      </Form>
      <div className="password">
        <Row>
          <Button variant="default" onClick={() => openPasswordModal()}>
            Alterar a senha.
          </Button>
        </Row>
      </div>
    </div>
  );
}

export default ProfileForm;